<template>
  <div>
    <div class="main-ttl container-xl">
      <h2>
        <span>{{ headingTitle }}</span>
        <small>{{ headingDesc }}</small>
      </h2>
    </div>

    <main v-if="item" class="container-xl">
      <div class="primary-area setting-area bg-none-sm">
        <HeaderSetting />

        <div class="outside-ttl-sm">
          <div class="section-ttl list-btn-area">
            <h3>基本情報</h3>
            <Button variant="circle" @click="edit">変更する</Button>
          </div>
        </div>

        <div class="bg-sm">
          <section class="primary-section basic-info">

            <dl class="row section-item single-item">
              <dt class="col-md-4">
                <label class="col-form-label">
                  アカウント名（組織名など)
                </label>
              </dt>
              <dd class="col-md-8 ps-3">
                <div>
                  {{ item.name }}
                  <span class="sub-txt gray inline">
                    SA-{{ item.organizationId }}
                  </span>
                </div>
              </dd>
            </dl>

            <dl class="row section-item single-item">
              <dt class="col-md-4">
                <label class="col-form-label">
                  契約ユーザー
                </label>
              </dt>
              <dd class="col-md-8 ps-3">
                <div>
                  {{ item.ownerUserName }}
                  <span class="sub-txt gray inline">
                    {{ item.ownerUserEmail }}
                  </span>
                </div>
              </dd>
            </dl>

            <dl class="row section-item single-item">
              <dt class="col-md-4">
                <label class="col-form-label">
                  支払情報
                </label>
              </dt>
              <dd class="col-md-8 ps-3">
                <div>
                  {{ item.paymentInfo.getPaymentMethodText() }}
                </div>
              </dd>
            </dl>

            <dl class="row section-item single-item">
              <dt class="col-md-4">
                <label class="col-form-label">
                  請求情報（社名）
                </label>
              </dt>
              <dd class="col-md-8 ps-3">
                <div>
                  {{ item.billingAddress?.companyName }}
                </div>
              </dd>
            </dl>

            <dl class="row section-item single-item">
              <dt class="col-md-4">
                <label class="col-form-label">
                  請求情報（住所）
                </label>
              </dt>
              <dd class="col-md-8 ps-3">
                <div>
                  〒{{ item.billingAddress.getPostalCodeText() }}
                  {{ item.billingAddress.getAddressText() }}
                </div>
              </dd>
            </dl>

            <dl class="row section-item single-item">
              <dt class="col-md-4">
                <label class="col-form-label">
                  請求情報（ご担当者名）
                </label>
              </dt>
              <dd class="col-md-8 ps-3">
                <div>
                  {{ item.billingAddress?.personInChargeName }}
                </div>
              </dd>
            </dl>

            <dl class="row section-item single-item">
              <dt class="col-md-4">
                <label class="col-form-label">
                  請求情報（ご連絡先電話番号）
                </label>
              </dt>
              <dd class="col-md-8 ps-3">
                <div>
                  {{ item.billingAddress?.phoneNumber }}
                </div>
              </dd>
            </dl>

            <dl class="row section-item single-item">
              <!-- empty element to add border below -->
            </dl>

          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Button } from "components";
import { HeaderSetting } from "containers";
import { TrashRedIcon } from "icons";

import {
  SCREEEN_STATUS_CD,
} from "models/screen-status";

/* リポジトリモジュール */
import { RepositoryFactory } from "repositories/factory";

const OrganizationsRepository = RepositoryFactory.get("organizations");

export default {
  name: "ServiceAccountIndex",
  components: {
    Button,
    HeaderSetting,
  },
  data() {
    return {
      icons: {
        TrashRedIcon,
      },
      headingTitle: "サービスアカウント設定",
      headingDesc: "サービスアカウントの登録情報です。",
      item: null,
    };
  },
  computed: {
    ...mapGetters({
      /* ログイン情報 */
      userAccount: "profile/userAccount",
      currentServiceAccount: "service-account/currentServiceAccount",
      currentAsigProject: "asig-project/currentAsigProject",
    }),
  },
  async created() {
    /* 初期化処理 */
    try {
      this.item = await OrganizationsRepository.get(this.currentServiceAccount.serviceAccountId);
      // 画面機能を有効化
      await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
    } catch (err) {
      console.log(err);
      this.setErrorNotification({
        message: "予期せぬエラーが発生しました。",
      });
    }
  },
  methods: {
    ...mapActions({
      /* 画面ステータス更新 */
      updateScreenStatusCd: "application/updateScreenStatusCd",
      /* 通知制御 */
      resetNotificaton: "notification/resetState",
      setErrorNotification: "notification/setErrorNotification",
    }),
    edit() {
      this.$router.push("/service-account/edit");
    },
  },
};
</script>
